import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forums',
  templateUrl: './forums.component.html',
  styleUrls: ['./forums.component.css'],
  standalone: false,
})
export class ForumsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
